export default "__VITE_ASSET__KuPzzN91__"